module.exports = __webpack_public_path__ + "static/media/collection-hatching.b477e583.png";